module.exports = __webpack_public_path__ + "img/touxiang.08803b0d.png";